import React, { Component } from 'react'
import { Field } from 'formik'
import { Input, Select, Checkbox } from '../../../ui/forms/formik'
import { Row, Col } from 'react-bootstrap'
import SelectSearch from '../../../ui/select/SelectSearchItems';
import { graphql, Query } from 'react-apollo';
import { gql } from '@apollo/client';

class CompanyDetailsForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isIndependent: false,
            selectedCountry: ''
        }
    }

    render() {
        const citiesList = [];
        const statesList = [];

        return (
            <div className="company-details-form">
                <Field
                    name="company"
                    placeholder="Enter Agency, Club or Team Name"
                    component={Input}
                    className="input input-flat input-xl"
                    groupClassName="form-group-company"
                    disabled={this.state.isIndependent}
                />
                <Field
                    name="isIndependent"
                    label="I am a independent Scout"
                    component={Checkbox}
                    onChange={value => this.setState({ isIndependent: value })}
                    checked={this.state.isIndependent}
                />
                <Field
                    name="address"
                    placeholder="Address"
                    component={Input}
                    className="input input-flat input-xl"
                />
                <Row>
                    <Col md={6}>
                        {this.renderCountriesSelect()}
                    </Col>
                    <Col md={6}>
                        <Field
                            name="state"
                            placeholder="State"
                            component={Select}
                            wrappedComponent={SelectSearch}
                            className="select select-flat select-xl"
                            options={statesList}
                        />
                    </Col>
                    <Col md={6}>
                        {this.renderCitySelect()}
                    </Col>
                    <Col md={6}>
                        <Field
                            name="zip_code"
                            placeholder="Zip/Pin Code"
                            component={Input}
                            className="input input-flat input-xl"
                            withoutMargin
                        />
                    </Col>
                </Row>
            </div>
        )
    }

    renderCountriesSelect = () => {
        return (
            <Query
                query={GET_COUNTRIES_QUERY}
            >
                {({ data, loading, error }) => {
                    const options = data?.countries.map(country => ({ label: country.name, value: country.id, key: country.id }))
                    
                    return (
                        <Field
                            name="country"
                            placeholder="Country"
                            component={Select}
                            wrappedComponent={SelectSearch}
                            onValueChange={optionValue => this.setState({ selectedCountry: optionValue })}
                            className="select select-flat select-xl"
                            loading={loading}
                            options={options}
                        />
                    )
                }}
            </Query>
        )
    }

    renderCitySelect = () => {
        return (
            <Query
                query={GET_COUNTRIES_QUERY}
            >
                {({ data, loading, error }) => {
                    const options = [];// data?.cities.map(country => ({ label: country.name, value: country.id, key: country.id }))
                    
                    return (
                        <Field
                            name="city"
                            placeholder="City"
                            component={Select}
                            wrappedComponent={SelectSearch}
                            searchPlaceholder="Search City"
                            className="select select-flat select-xl"
                            searchProps={{ className: "select select-white select-lg" }}
                            withoutMargin
                            options={options}
                        />
                    )
                }}
            </Query>
        )
    }
}

const GET_COUNTRIES_QUERY = gql`
{
    countries: getCountries{
        id
        name
    }
}
`

export default CompanyDetailsForm